// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accreditation-container {
    max-width: 700px;
    margin: 0 auto;
    padding: 2rem 1.5rem;
    line-height: 1.6;
}

.accreditation-section {
    margin-bottom: 2rem;
}

    .accreditation-section h2 {
        font-size: 1.4rem;
        margin-bottom: 0.5rem;
        border-bottom: 1px solid var(--color-border);
        padding-bottom: 0.25rem;
    }

    .accreditation-section p {
        margin: 0.25rem 0;
        font-size: 1.05rem;
    }
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/Accreditation.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;IAEI;QACI,iBAAiB;QACjB,qBAAqB;QACrB,4CAA4C;QAC5C,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.accreditation-container {\r\n    max-width: 700px;\r\n    margin: 0 auto;\r\n    padding: 2rem 1.5rem;\r\n    line-height: 1.6;\r\n}\r\n\r\n.accreditation-section {\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n    .accreditation-section h2 {\r\n        font-size: 1.4rem;\r\n        margin-bottom: 0.5rem;\r\n        border-bottom: 1px solid var(--color-border);\r\n        padding-bottom: 0.25rem;\r\n    }\r\n\r\n    .accreditation-section p {\r\n        margin: 0.25rem 0;\r\n        font-size: 1.05rem;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
